import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Grid, MenuItem } from '@mui/material';
import { OptionLabel } from '../option-label';
import { FieldArrayWithId, FieldErrors, useFormContext } from 'react-hook-form';
import { ISelectionFormValues } from 'widgets/selections/utils/types';
import { styles } from './styles';

interface ISortableMenuItem {
  field: FieldArrayWithId<Pick<ISelectionFormValues, 'options'>, 'options', 'key'>;
  canMove: boolean;
  selectedValue: string;
  index: number;
  errorsOptions: FieldErrors<Pick<ISelectionFormValues, 'options'>>;
  onSelect: (value: string) => void;
  onClose: () => void;
}

export const SortableMenuItem = ({
  field,
  canMove,
  errorsOptions,
  index,
  selectedValue,
  onSelect,
  onClose,
}: ISortableMenuItem) => {
  const form = useFormContext<Pick<ISelectionFormValues, 'options'>>();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: field.id,
  });

  const text = form.watch(`options.${index}.title`);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    width: '100%',
    boxSizing: 'border-box',
  } as React.CSSProperties;

  return (
    <MenuItem
      aria-selected={selectedValue === field.id ? 'true' : 'false'}
      ref={setNodeRef}
      value={field.id}
      selected={selectedValue === field.id}
      onClick={() => {
        if (!isDragging) {
          onSelect(field.id);
          onClose();
        }
      }}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        py: 1.5,
        px: 3,
        cursor: 'default',
        ...style,
      }}
    >
      <Grid sx={styles.menuItemContainer}>
        {canMove && (
          <Box {...attributes} {...listeners} sx={{ cursor: 'move' }}>
            ☰
          </Box>
        )}
        <OptionLabel text={text || 'Untitled Option'} hasError={!!errorsOptions?.[index]} />
      </Grid>
    </MenuItem>
  );
};
